import { useMemoizedFn, useSafeState } from "ahooks";
import classNames from "classnames";
import { useEffect } from "react";
import styles from "./index.module.less";

interface FadeInProps {
  show?: boolean;
  /**控制隐藏方向 */
  direction?: "up" | "down";
  children?: React.ReactNode;
  duration?: number;
  delay?: number;
  className?: string;
}

/**
 * 上下显示隐藏。透明到显示的渐变显示
 */
export default function PageTransition({
  direction = "up",
  show = true,
  delay = 0,
  children = null,
  className = "",
}: FadeInProps = {}) {
  const [fadeClassName, setFadeClassName] = useSafeState<string>(
    styles.fadeOutDone
  );

  // const fadeClassName = useMemo(() => {
  //   if (show) {
  //     return styles.fadeShow;
  //   } else {
  //     if (direction === "up") {
  //       // 向上隐藏
  //       return styles.fadeOutUp;
  //     } else {
  //       // 向下隐藏
  //       return styles.fadeOutDown;
  //     }
  //   }
  // }, [show, direction]);

  const onShow = useMemoizedFn(() => {
    setFadeClassName((prev) => {
      if (prev.includes(styles.fadeOutDone)) {
        return prev.replace(styles.fadeOutDone, "");
      } else {
        return styles.fadeShow;
      }
    });

    return setTimeout(() => {
      setFadeClassName(styles.fadeShow);
    }, 100);
  });

  const onHide = useMemoizedFn(() => {
    if (direction === "up") {
      // 向上隐藏
      setFadeClassName(styles.fadeOutUp);
    } else {
      // 向下隐藏
      setFadeClassName(styles.fadeOutDown);
    }

    return setTimeout(() => {
      setFadeClassName((prev) => prev + " " + styles.fadeOutDone);
    }, delay + 600);
  });

  useEffect(() => {
    let timer;
    if (show) {
      timer = onShow();
    } else {
      timer = onHide();
    }
    return () => {
      clearTimeout(timer);
    };
  }, [onHide, onShow, show]);

  return (
    <div
      className={classNames(className, fadeClassName, styles.fade)}
      style={{
        transitionDelay: delay + "ms",
      }}
    >
      {children}
    </div>
  );
}
